import * as PIXI from 'pixi.js';
import Vector from "../Game/Base/Math/Vector";
import CanvasButton from "./CanvasButton";
import Global from '../Game/Global'
import { Shape } from '../Game/Level/Blok';

export default class CanvasBlokButton extends CanvasButton {
    constructor(parent) {
        super(parent);

        this.blok = null;
    }

    checkUICollision(position) {
        if (!this.blok._hasVisuals)
            return false;
        const pixiPoint = new PIXI.Point();
        this.blok.pixiContainer.worldTransform.applyInverse(position.makePIXIPoint(), pixiPoint);
        const buttonSpacePosition = Vector.fromPIXIPoint(pixiPoint);

        if (this.blok.shape === Shape.rectangle) {
            if (buttonSpacePosition.x < -this.blok.size.x * Global.NATIVE_BLOCK_SIZE / 2)
                return false;
            if (buttonSpacePosition.y < -this.blok.size.y * Global.NATIVE_BLOCK_SIZE / 2)
                return false;
            if (buttonSpacePosition.x > +this.blok.size.x * Global.NATIVE_BLOCK_SIZE / 2)
                return false;
            if (buttonSpacePosition.y > +this.blok.size.y * Global.NATIVE_BLOCK_SIZE / 2)
                return false;
            return true;
        }
        // Circle
        if (buttonSpacePosition.length() < this.blok.size.x * Global.NATIVE_BLOCK_SIZE / 2)
            return true;
        return false;
        
    }

    onHoverEnter() { }

    onHoverExit() { }

    onMouseDown() { }

    onMouseMove() { }

    onMouseUp() { }
}